export const durationFormatter = (minutes) => {
    if (minutes == null) return "-";

    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    const parts = [];
    if (hours > 0) parts.push(`${hours} hr`);
    if (remainingMinutes > 0) parts.push(`${remainingMinutes} min`);

    return parts.length > 0 ? parts.join(" ") : "-";
};